export function initLinks() {
    const currentHost = window.location.host;
    document.querySelectorAll('a[href]')?.forEach(link => {
        const href = link.getAttribute('href');
        const existingTarget = link.getAttribute('target');
        if (!href || href.startsWith('javascript:') || href.startsWith('mailto:') || href.startsWith('tel:'))
            return;
        const isFile = /\.(pdf|docx?|xlsx?|zip|rar|7z|mp3|mp4|avi|mov)$/i.test(href);
        try {
            const url = new URL(href, window.location.href);
            const isExternal = url.host !== currentHost;
            if ((isFile || isExternal) && existingTarget !== '_blank') {
                link.setAttribute('target', '_blank');
                let rel = link.getAttribute('rel') || '';
                if (!rel.includes('noopener'))
                    rel += ' noopener';
                if (!rel.includes('noreferrer'))
                    rel += ' noreferrer';
                link.setAttribute('rel', rel.trim());
            }
            else if (!isFile && !isExternal && existingTarget && existingTarget !== '_self') {
                link.setAttribute('target', '_self');
            }
        }
        catch (e) {
            if (existingTarget && existingTarget !== '_self') {
                link.setAttribute('target', '_self');
            }
        }
    });
}
